export interface Expense {
  id: string;
  title?: string;
  merchant?: string;
  date?: string;
  created?: string;
  amount: number;
  status: string;
  syncToGlStatus: string;
}

export interface ExpenseReport {
  id: string;
  title?: string;
  userId?: string;
  scheduledToReimburseDate?: Record<string, string>;
  amounts?: { totalSpent: number };
  status: string;
  syncToGlStatus: string;
}

export interface Transaction {
  id: string;
  merchant?: string;
  amount: number;
  postingDate?: string;
  created?: string;
  status?: string;
  syncToGlStatus: string;
  last4?: string;
}

export interface Cursor {
  id: string;
  created: string;
}

export interface CursorPaginatedResponse<T> {
  payload: {
    data: T[];
    cursor: Cursor | null;
  };
}

export const SYNC_STATUS_OPTIONS = [
  { value: 'ready', label: 'ready' },
  { value: 'synced', label: 'synced' },
  { value: 'failed', label: 'failed' },
  { value: 'notReady', label: 'notReady' },
  { value: 'processing', label: 'processing' },
];

export const SYNC_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  ...SYNC_STATUS_OPTIONS,
];
